import RankThirteen from '@assets/icons/rank-thirteen.svg'
import { Icon } from './Icon'

export const RankThirteenIcon = Icon(RankThirteen)
